import angular from 'angular';
import reportType from './reportType';
import directive from './report-types.directive';
import controller from './report-types.controller';


export default angular.module('app.components.reports.scheduledReports.reportTypes', [
  reportType
])
  .directive('srReportTypes', directive)
  .controller('SRReportTypesController', controller)
  .name;

console.log('app.components.reports.scheduledReports.reportTypes created');
